export const ACTIVE_TAB_QUERY_PARAM = 'activeTab';

export const US_ACTIVE_CALENDAR_TAB = {
  ACTIVE_DEALS: 'active-deals',
  MANDATE: 'mandate',
} as const;

export type USActiveCalendarTabType = typeof US_ACTIVE_CALENDAR_TAB[keyof typeof US_ACTIVE_CALENDAR_TAB];

interface ITabConfig {
  id: USActiveCalendarTabType,
  name: string,
}

export const US_ACTIVE_CALENDAR_TABS_CONFIG: Record<USActiveCalendarTabType, ITabConfig> = {
  [US_ACTIVE_CALENDAR_TAB.ACTIVE_DEALS]: {
    id: US_ACTIVE_CALENDAR_TAB.ACTIVE_DEALS,
    name: 'Active Deals',
  },
  [US_ACTIVE_CALENDAR_TAB.MANDATE]: {
    id: US_ACTIVE_CALENDAR_TAB.MANDATE,
    name: 'Mandates',
  },
} as const;
